import CRUD from "@/firebase/crud";
import store from "@/store/index";
import filter from "lodash-es/filter";
import find from "lodash-es/find";

const portal = {
  namespaced: true,
  state: {
    active: {},
    list: [],
    lookups: {},
    sponsors : {},
    lookupsResult: {}
  },
  getters: {
    lookupList: state => list => {
      // // console.log("list = " + list)
      return filter(state.lookups, function(item) {
        return item.lookup === list;
      });
    },
    sponsorList: state => list => {
      // // console.log("list = " + list)
      return filter(state.sponsors, function(item) {
        return item.sponsors === list;
      });
    },
    lookupListField: state => (list, value, searchField, resultField) => {
      if (value === undefined) {
        return "";
      } else {
        var lookup = filter(state.lookups, function(item) {
          return item.lookup === list;
        });
        if (lookup.length === 0) {
          return "";
        } else {
          var findValue = find(lookup, function(item) {
            return item[searchField] === value;
          });
          if (findValue[resultField] !== undefined) {
            return findValue[resultField];
          } else {
            return "";
          }
        }
      }
    }
  },
  mutations: {
    setActive(state, data) {
      // used to Set the active with the Resource Timeslots
      state.active = data;
    },
    setActiveValue(state, [name, data]) {
      // Used to update the active Value
      state.active[name] = data;
    },
    setdeviceValue(state, [name, data]) {
      // Used to update the device Value
      state.device[name] = data;
    },
    setLookups(state, data) {
      state.lookups = data;
    },
    setLookupsResult(state, data) {
      state.lookupsResult = data;
    }
  },
  actions: {
    readLookups: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        let Res = payload[3];
        store.commit(Mutation, []);
        if (portalID !== undefined) {
          let Result = Promise.resolve(
            CRUD.ReadDocuments(Collection, portalID, null)
          );
          Result.then(Response => {
            switch (Response.result) {
              case "success":
                store.commit(Mutation, Response.data);
                break;
              case "failure":
                store.commit(Res, Response.message);
                break;
              case "error":
                store.commit(Res, Response.message);
                break;
              default:
                store.commit(Res, Response.message);
                break;
            }
          });
        } else {
          // Return Nothing Emtpy Lookups
        }
      } catch (err) {
        store.commit("portal/setLookupsResult", "Error");
      }
    }
  }
};

export default portal;
